import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pill',
  templateUrl: 'pill-button.component.html',
  styleUrls: ['pill-button.component.scss'],
})
export class PillButtonComponent implements OnInit {
  @Input() label: string;
  @Input() active = false;
  @Input() size: 'sm' | 'lg' = 'sm';
  @Input() showCheck = false;
  @Output() toggled = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  onClick(): void {
    this.toggled.emit();
  }
}
